import React from "react";
import { cLog, cWarn } from "../../CustomLogger";
import axios from "../../../../utils/axios";

export const GetOtherDomesticAddressPlaceholders = async (pointContext) => {
   
    const{
        state:{
            point:pointObject,
            point:{
                destination:{
                    friendlyAddress,
                    addressId = 0,
                    additionalAddress:destinationAdditionalAddress=null
                },
                additionalAddress=false
            },
            searchRes
        },
        textContent,
        bookingConfig
     } = pointContext;

    let driverType = '';
    
    const {driverTypesMap} = bookingConfig;


    const cDetails = {
        contactName:'',
        contactNumber:'',
        contactRelation:'',
        set:false
    };

    
    if(destinationAdditionalAddress){
        cDetails.contactName = destinationAdditionalAddress.contactName;
        cDetails.contactNumber = destinationAdditionalAddress.contactNumber;
        if('contactRelation' in destinationAdditionalAddress) {
            cDetails.contactRelation = destinationAdditionalAddress.contactRelation;
        }
        cDetails.set = true;
    }
    else if(additionalAddress){
        cDetails.contactName = additionalAddress.contactName;
        cDetails.contactNumber = additionalAddress.contactNumber;
        if('contactRelation' in additionalAddress) {
            cDetails.contactRelation = additionalAddress.contactRelation;
        }
        cDetails.set = true;
    }
    let contactDetails = {};

    cLog(pointObject);
    cLog(cDetails);
    if (addressId && !cDetails.set) {
        if(!searchRes){
            const apiPath = `${process.env.REACT_APP_API_URL}/getotheraddress/${addressId}`;
            await axios.get(apiPath,{
                timeout: 300000,
                withCredentials:true
            }).then((res) => {
                ({
                    data:{
                        addressData:contactDetails=[]
                    }
                } = res);
                
            }).catch(err => {
                cWarn(err);
            });
        }
    }
    
    contactDetails = {...cDetails,...contactDetails};
    cLog(contactDetails);

    const{
        contactName='',
        contactNumber='',
        contactRelation=null
    } = contactDetails;

    if (contactRelation in driverTypesMap) {
        try {
            driverType = textContent[driverTypesMap[contactRelation].textKey];
        } catch (e) {
            console.warn('Failed to parse driver type');
        }
    } 
    

    const bodyText = (
        <>            
            {friendlyAddress}<br/>
            {contactName && contactName} {driverType && <>({driverType})</>}<br/>
            {contactNumber && contactNumber}
        </>
    );
    return {
        bodyText,
    };


}